import OneSignal from "react-onesignal";
import AppConfig from "./helpers/config";
import {ServicePostPackageTag} from "./services/NotificationService";

const fetchAndSendIds = async () => {
    try {
        const oneSignalId = OneSignal.User.onesignalId;
        const subscriptionId = OneSignal.User.PushSubscription.id;

        if (oneSignalId && subscriptionId) {
            const params = {
                player_id: oneSignalId,
                subscription_id: subscriptionId,
                platform: "web",
                device_type: "desktop",
                device_name: navigator.userAgent,
            };

            await ServicePostPackageTag(params);

            localStorage.setItem("oneSignalId", oneSignalId);
            localStorage.setItem("subscriptionId", subscriptionId);
        }
    } catch (error) {
        console.error("Error fetching OneSignal IDs (Web):", error);
    }
};

export const initOneSignal = async () => {
    await OneSignal.init({
        appId: AppConfig.oneSignalKey,
        notifyButton: {enable: true},
        allowLocalhostAsSecureOrigin: true,
    });
};

export const requestNotificationPermission = async () => {
    // 🔔 Request permission if not granted
    if (!OneSignal.Notifications.permission) {
        await OneSignal.Notifications.requestPermission();
    }

    // ✅ FORCE opt-in (critical for web)
    await OneSignal.User.PushSubscription.optIn();

    // ⏳ Wait briefly for subscription to be ready
    let retries = 5;
    while (
        retries-- &&
        (!OneSignal.User.onesignalId ||
            !OneSignal.User.PushSubscription.id)
        ) {
        await new Promise((res) => setTimeout(res, 500));
    }

    // 🚀 Send IDs
    await fetchAndSendIds();
};
